import React, {useState} from 'react';
import {Box, styled, Tab, Tabs} from '@mui/material';
import PropTypes from 'prop-types';

const BRAND_GREEN = '#0A8572';
const DARK_SUBTLE = '#355F54';

const PanelContainer = styled('div')(({theme}) => ({
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
}));

const TabsBar = styled(Tabs)({
    backgroundColor: '#fff',
    minHeight: 48,
});

const AdmicityTabs = ({
                          tabs,
                          variant = 'standard',
                          displayDivider = false,
                          onChange,
                          tabIndex,
                      }) => {
    const [internalIndex, setInternalIndex] = useState(0);
    const controlled = typeof onChange === 'function';

    const handleTabChange = (_, newValue) => {
        controlled ? onChange(newValue) : setInternalIndex(newValue);
    };

    const activeIndex = controlled ? tabIndex : internalIndex;
    const ActivePanel = tabs[activeIndex].component;

    const tabsBar = (
        <TabsBar
            value={activeIndex}
            onChange={handleTabChange}
            textColor="inherit"
            variant={variant}
            TabIndicatorProps={{
                style: {
                    backgroundColor: BRAND_GREEN,
                    height: 3,
                    borderRadius: 2,
                },
            }}
        >
            {tabs.map(({label}, index) => (
                <Tab
                    key={label ?? index}
                    value={index}
                    label={label}
                    sx={{
                        color: DARK_SUBTLE,
                        opacity: 1,
                        fontWeight: 500,
                        minHeight: 48,
                        '&.Mui-selected': {color: BRAND_GREEN},
                    }}
                />
            ))}
        </TabsBar>
    );

    return (
        <>
            {displayDivider
                ? (
                    <Box sx={{
                        borderBottom: 1,
                        borderColor: 'divider'
                    }}>{tabsBar}</Box>
                )
                : (
                    tabsBar
                )}
            <PanelContainer>{ActivePanel}</PanelContainer>
        </>
    );
};

AdmicityTabs.defaultProps = {
    tabs: [],
    variant: 'standard',
    displayDivider: false
};

AdmicityTabs.propTypes = {
    tabs: PropTypes.array,
    variant: PropTypes.string,
    displayDivider: PropTypes.bool,
    onChange: PropTypes.func,
    tabIndex: PropTypes.number
};

export default AdmicityTabs;